export default __webpack_public_path__ + "static/on_seeing_mr_penniman-30dab335c3594e1ef9f74367b88b3097.jpg";